export default __webpack_public_path__ + "static/media/supplier-login-congratulations.ca8de073.png";